import React from 'react'
import { Layout } from 'antd'

const { Content } = Layout

export default function EmptyCenteredFlexLayout(props) {
  return (
    <Layout className='app'>
      <Content className='d-flex justify-content-center align-items-center'>{props.children}</Content>
    </Layout>
  )
}
